export const GET_COMPTE_TIERS = 'GET_COMPTE_TIERS'
export const GET_COMPTE_TIERS_SUCCESS = 'GET_GET_COMPTE_TIERS_SUCCESS'
export const GET_COMPTE_TIERS_FAILURE = 'GET_COMPTE_TIERS_FAILURE'

export const GET_COMPTE_TIERS_LIST_MORE = 'GET_COMPTE_TIERS_LIST_MORE'
export const GET_COMPTE_TIERS_LIST_MORE_FAILURE =
  'GET_COMPTE_TIERS_LIST_MORE_FAILURE'
export const GET_COMPTE_TIERS_LIST_MORE_SUCCESS =
  'GET_COMPTE_TIERS_LIST_MORE_SUCCESS'

export const PAGE_LIMIT_CHANGED = 'PAGE_LIMIT_CHANGED'
export const PAGE_CHANGED = 'PAGE_CHANGED'

export const REMOVE_ERROR = 'REMOVE_ERROR'
export const RESET_SUCCESS_ACTION = 'RESET_SUCCESS_ACTION'
export const RESET_CONFIG = 'RESET_CONFIG'

export const SEARCH_COMPTE_TIERS = 'SEARCH_COMPTE_TIERS'

export const ADD_COMPTE_TIERS = 'ADD_COMPTE_TIERS'
export const ADD_COMPTE_TIERS_SUCCESS = 'ADD_COMPTE_TIERS_SUCCESS'
export const ADD_COMPTE_TIERS_FAILURE = 'ADD_COMPTE_TIERS_FAILURE'

export const UPDATE_COMPTE_TIERS = 'UPDATE_COMPTE_TIERS'
export const UPDATE_COMPTE_TIERS_SUCCESS = 'UPDATE_COMPTE_TIERS_SUCCESS'
export const UPDATE_COMPTE_TIERS_FAILURE = 'UPDATE_COMPTE_TIERS_FAILURE'
